import { defineGameCard, onResolve } from '../authoring/index.js';
import { plannedTarget } from './helpers.js';
export const LiquidCoolingCard = defineGameCard({
    id: 'liquid_cooling',
    gameplay: {
        type: 'SPELL', cost: 1,
        planning: { target: 'unit', unitFilter: 'ally' },
    },
    presentation: {
        name: 'Жидкостное охлаждение',
        description: 'Охладите выбранную союзную карту на 2. Дайте ей Щит 1.',
        glyph: {
            colors: ['#10213A', '#4B93D3', '#3569B5', '#495171', '#84534B'],
            rows: [
                '.......1111111......',
                '.....1122222221.....',
                '....123333131121....',
                '....1211111111321...',
                '....131......1121...',
                '...11311111..1321...',
                '..1455555551.1321...',
                '..1445555551.1321...',
                '..1444444441.1321...',
                '..1445554551.1321...',
                '..1444444441.1321...',
                '..1455555551.1321...',
                '..1444444441.1321...',
                '..1445554551.1321...',
                '...11111111..1321...',
                '...12332131111331...',
                '...1211311133331....',
                '...1331213331131....',
                '....11.1.111111.....',
                '....................',
            ],
        },
    },
    role: 'playable',
    abilities: [
        onResolve((ctx) => {
            const targetId = plannedTarget(ctx);
            if (targetId === undefined)
                return;
            ctx.ops.cool(targetId, 2);
            ctx.ops.addShield(LiquidCoolingCard.id, targetId, 1, ctx.self.id);
        }),
    ],
    ui: { mechanics: ['heat', 'cool', 'shield'] },
});
//# sourceMappingURL=liquid-cooling.js.map